import React, { PropTypes } from 'react';
import Dialog from 'material-ui/Dialog';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import FlatButton from 'material-ui/FlatButton';

class EditDialog extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    saveButton: PropTypes.element,
    disabledSave: PropTypes.bool,
    onDialogClose: PropTypes.func,
    onDialogClosed: PropTypes.func,
    onSubmit: PropTypes.func
  };

  static contextTypes = {
    muiTheme: React.PropTypes.object
  };

  state = {
    open: false
  };

  props = {
    disabledSave: true
  };

  componentDidMount() {
    this.setState({open: true});
  }

  closeModal(saved = false) {
    let { onDialogClose, onDialogClosed } = this.props;
    if (onDialogClose !== undefined) {
      onDialogClose(saved);
    }

    this.setState({open: false});

    if (onDialogClosed  !== undefined) {
      setTimeout(() => onDialogClosed(saved), 450);
    }
  }

  save() {
    return Promise.resolve(this.props.onSubmit())
      .then(() => this.closeModal(true))
      /* eslint no-console: 0 */
      .catch(err => err instanceof Error ? console.error(err) : null);
  }

  _renderSaveButton() {
    let { disabledSave, saveButton } = this.props;
    let {palette: {labelColor}} = this.context.muiTheme;
    if (saveButton) {
      return React.cloneElement(saveButton);
    } else if(saveButton === null) {
      return null;
    } else {
      return (<FlatButton style={{color: labelColor}} label="Save" disabled={disabledSave} onClick={() => this.save()}/>);
    }
  }

  render() {
    let {
          children,
          title
          } = this.props;

    let {palette: {labelColor}} = this.context.muiTheme;

    let modalAppBar = (<AppBar
      title={<span>{title}</span>}
      iconElementLeft={<IconButton onClick={()=>this.closeModal()}><NavigationClose color={labelColor}/></IconButton>}
      iconElementRight={this._renderSaveButton()}
      titleStyle={{color: labelColor}}
    />);

    return (


      <Dialog
        title={modalAppBar}
        titleStyle={{paddingTop: 0, paddingBottom: 0, color: labelColor}}
        open={this.state.open}
        autoScrollBodyContent={true}
      >
        {children}
      </Dialog>
    );
  }
}

export default EditDialog;




// WEBPACK FOOTER //
// ./src/components/EditDialog.jsx